import { atom, useRecoilState, useRecoilValue } from 'recoil';

export type RemoteDialogInfo = {
  dialogId: string;
  dialogParams?: unknown;
  instanceId: string;
  onClose?: (answer: unknown) => void;
};

export const dialogsStackAtom = atom<RemoteDialogInfo[]>({
  default: [],
  key: 'dialogsStackAtom',
});

export function useCurrentDialogInfo() {
  const dialogsStack = useRecoilValue(dialogsStackAtom);
  const lastIndex = dialogsStack.length - 1;
  return lastIndex > -1 ? dialogsStack[lastIndex] : undefined;
}

export function useCancelAllDialogs() {
  const [stack, setStack] = useRecoilState(dialogsStackAtom);

  return () => {
    if (stack.length === 0) {
      return;
    }
    const reversedDialogInfos = [...stack].reverse();
    reversedDialogInfos.forEach((info) => {
      if (info.onClose) {
        info.onClose(undefined);
      }
    });
    setStack([]);
  };
}
